import * as React from "react";

// gradient-card imports
import { styles } from "./GradientCard.styles";

// material-ui
import { Button, Typography } from "@material-ui/core";
import { Close, NavigateNext } from "@material-ui/icons";
import withStyles, { CSSProperties, WithStyles } from "@material-ui/core/styles/withStyles";

export interface IContainer {
  cardStyle?: CSSProperties;
  hideDismissButton?: boolean;
  isDismissed?: boolean;
  href?: string;
  buttonLabel: string;
  label: string;
}

export interface IProps extends WithStyles<typeof styles>, IContainer {
  onDismiss: () => void;
  onClick: () => void;
}

export interface IState {
  dismissedPromotion: boolean;
}

///////////////
// Component //
///////////////
class GradientCardCmpt extends React.Component<IProps, IState> {
  static defaultProps = {
    onClick: () => undefined,
    onDismiss: () => undefined,
  };

  constructor(props: IProps) {
    super(props);

    this.state = {
      dismissedPromotion: !!props.isDismissed,
    };
  }

  private onDismissPromotion = () => {
    this.setState(
      {
        dismissedPromotion: true,
      },
      this.props.onDismiss,
    );
  };

  public render() {
    const optionalProps = this.props.href ? { href: this.props.href, target: "_blank" } : {};

    return !this.state.dismissedPromotion ? (
      <div className={this.props.classes.card} style={this.props.cardStyle}>
        {!this.props.hideDismissButton ? (
          <Close onClick={this.onDismissPromotion} className={this.props.classes.dismissIcon} />
        ) : null}
        <div className={this.props.classes.cardContent}>
          <Typography variant="h6" className={this.props.classes.h6}>
            {this.props.label}
          </Typography>
          <Button
            {...optionalProps}
            className={this.props.classes.ctaButton}
            classes={{
              label: this.props.classes.ctaButtonLabel,
            }}
            variant="contained"
            color="primary"
            onClick={this.props.onClick}
          >
            {this.props.buttonLabel}
            <NavigateNext className={this.props.classes.ctaButtonIcon} />
          </Button>
        </div>
      </div>
    ) : null;
  }
}

/////////////////
// With Styles //
/////////////////
export const GradientCard = withStyles(styles)(GradientCardCmpt);
